import React from 'react';
import { View, StyleSheet } from 'react-native';
import useColors from 'hooks/useColors';
import Text from './Text';
import StatusIcon from './StatusIcon';
import { IconIndicator } from './icons';
import IconStatusDone from './icons/status/IconStatusDone';
import IconStatusPending from './icons/status/IconStatusPending';
import Spacer from './Spacer';
const ICON_SIZE = 16;
const TEXT_COLOR_PROP = {
    verified: { Positive: true },
    pending: { StatusInformational: true },
    rejected: { Negative: true },
    unverified: { Secondary: true },
};
const renderIcon = (state, colors) => {
    switch (state) {
        case 'verified':
            return (<IconStatusDone width={ICON_SIZE} height={ICON_SIZE} color={colors.elements.statusPositive}/>);
        case 'pending':
            return (<IconStatusPending width={ICON_SIZE} height={ICON_SIZE} bgColor={colors.status.informational} color={colors.background.dark}/>);
        case 'rejected':
            return (<StatusIcon width={ICON_SIZE} height={ICON_SIZE} state="cancelled-red"/>);
        case 'unverified':
        default:
            return (<IconIndicator colorKey="secondary" width={ICON_SIZE} height={ICON_SIZE}/>);
    }
};
const VerificationStatusView = React.memo(({ state, label, style, ...props }) => {
    const colors = useColors();
    return (<View style={[styles.row, style]} {...props}>
        {renderIcon(state, colors)}
        <Spacer w={8}/>
        <Text TextThin-14 {...TEXT_COLOR_PROP[state]}>
          {label}
        </Text>
      </View>);
});
VerificationStatusView.displayName = 'VerificationStatusView';
export default VerificationStatusView;
const styles = StyleSheet.create({
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
});
